import React from "react";
import { colorForKind } from "shared/components/spans/KindTag";

/**
 * Render a tiny "[Agent]" / "[Span · tool]" chip next to a funnel step
 * label so mixed-kind funnels are visually disambiguated. Returns null
 * for plain event-kind steps (no chip needed — events are the default).
 */
export function renderStepKindChip(step) {
  if (!step) return null;
  const entityKind = step.entityKind;
  if (entityKind === 'agent') {
    return (
      <span
        className="ml-1.5 inline-flex items-center rounded px-1.5 py-0.5 align-middle text-[9px] font-semibold uppercase tracking-wide"
        style={{ color: colorForKind('run').color, backgroundColor: `color-mix(in srgb, ${colorForKind('run').color} 14%, transparent)` }}
        title="Agent run"
      >
        Agent
      </span>
    );
  }
  if (entityKind === 'span') {
    const sk = step.spanKind || 'span';
    const color = colorForKind(sk);
    return (
      <span
        className="ml-1.5 inline-flex items-center rounded px-1.5 py-0.5 align-middle text-[9px] font-semibold uppercase tracking-wide"
        style={{ color: color.color, backgroundColor: `color-mix(in srgb, ${color.color} 14%, transparent)` }}
        title={`Span · ${sk}`}
      >
        Span{step.spanKind ? ` · ${step.spanKind}` : ''}
      </span>
    );
  }
  return null;
}
